import { cn } from "@/lib/utils";
import { Bell } from "lucide-react";
import { Button } from "./ui/button";

interface NotificationBellProps {
  count?: number;
  onClick?: () => void;
  className?: string;
}

const NotificationBell = ({
  count = 0,
  onClick,
  className,
}: NotificationBellProps) => {
  const hasNotifications = count > 0;
  const displayCount = count > 99 ? "99+" : count;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("relative h-10 w-10", className)}
      onClick={onClick}
      aria-label={`Notifications${hasNotifications ? ` (${count} unread)` : ""}`}
    >
      <Bell className="h-6 w-6" />
      {hasNotifications && (
        <span
          className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-destructive px-1 text-[11px] font-semibold text-destructive-foreground"
          aria-hidden="true"
        >
          {displayCount}
        </span>
      )}
    </Button>
  );
};

export default NotificationBell;
